import { render, staticRenderFns } from "./report-general-view.vue?vue&type=template&id=aa35e63c&"
import script from "./report-general-view.vue?vue&type=script&lang=js&"
export * from "./report-general-view.vue?vue&type=script&lang=js&"
import style0 from "./report-general-view.vue?vue&type=style&index=0&id=aa35e63c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports